export default "__VITE_ASSET__ClZAi9tM__"